import React from "react";
import BoxData from "../Box";
import CardNav from "../CardNav";
import { Col, Row, Card } from "react-bootstrap";
import { images } from "../../../../constants";

const SellSingleitem = ({ btn, title }) => {
  const singleItemInfo = (
    <>
      <p>
        The <strong>Single Item Platform</strong> is a marketplace designed for <strong>consumer-to-consumer (C2C)</strong> selling.
      </p>
      <p>
        On this platform, users can search daily listings for individual items being sold directly by consumers. These are <strong>single-item advertisements</strong>, meaning there is no requirement to create a shop or register a business.
      </p>
      <p>
        This platform allows users to easily buy or sell personal items, making it <strong>simple, fast, and accessible</strong> for everyday users who want to trade individual products.
      </p>
           <a href="https://www.youtube.com" target="_blank">
  <strong>Click here to see how to Explore the Items</strong>
</a>
    </>
    
  );

  return (
    <div>
      <Row>
        <Col lg="12">
          {/* CardNav displays title + info */}
          <CardNav Header={title} myid={1} myinfo={singleItemInfo} />

          {/* BoxData for single item */}
          <Card className="shadow-main mt-lg-2 mt-md-3 mt-sm-2">
            <BoxData
              Title="Single Item"
              Butonn={btn}
              imgg={images.SingleAdds}
              url="/post-single-ad"
              link="/single-item-buy"
              ms="fourteen-element"
              buy="fourteen"
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default SellSingleitem;
